import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import {DeviceViewModel} from "../../../../core/models/device.view-model";

export class PreviousMeetingsWidgetGamePlaceholderProps extends BaseProps {
  device: DeviceViewModel;
  isRecentForm: Boolean;
}

export const PreviousMeetingsWidgetGamePlaceholder = (props: PreviousMeetingsWidgetGamePlaceholderProps) => {
  return (
    <PlaceholderWrapperComponent className={'previous-meetings-widget-placeholder-game-container'}>
      <div className={'previous-meetings-widget-placeholder-game-content'}>
        <div className={'previous-meetings-widget-placeholder-game-side-container'}>
          {!props.device.isSmallView && <div className={'previous-meetings-widget-placeholder-game-date'}/>}
        </div>
        <div className={'previous-meetings-widget-placeholder-game-center-container'}>
          <div className={'previous-meetings-widget-placeholder-game-team-name'}/>
          <div className={'previous-meetings-widget-placeholder-game-score-text'}/>
          <div className={'previous-meetings-widget-placeholder-game-team-name'}/>
        </div>
        <div className={'previous-meetings-widget-placeholder-game-side-container'}>
          {
            props.isRecentForm && <div className={'previous-meetings-widget-placeholder-game-balloon'}/>
          }
        </div>
      </div>
    </PlaceholderWrapperComponent>
  )
}
